import { combineReducers } from "redux";
import Attendancereducer from "./attendanceReducer";
import CustomerReducer from "./customerReducer";
import EmployeeReducer from "./employeeReducer";
import ErrorReducer from "./errorReducer";
import LoadingReducer from "./loadingReducer";
import OrganizationReducer from "./oraganizationReducer";
import SetUpDetailsMainReducer from "./SetUpDetailsMainReducer";
import UserManagementReducer from "./userManagementReducer";
import UserReducer from "./userReducer";

const rootReducer = combineReducers({
  user: UserReducer,
  loading: LoadingReducer,
  error: ErrorReducer,
  organization: OrganizationReducer,
  customer: CustomerReducer,
  attendance: Attendancereducer,
  employee: EmployeeReducer,
  userManagement: UserManagementReducer,
  setUpDetails: SetUpDetailsMainReducer,
});

export default rootReducer;
